import PropTypes from 'prop-types';
import styles from 'styles/TextInput.module.scss';

const TextArea = ({ fieldName, setValue, placeholder = '', value = '', label = null }) => {
    const onChange = e => {
        setValue(e.target.value);
    };

    if (value === null) {
        return null;
    }

    return (
        <>
            {label && <label htmlFor={fieldName}>{label}</label>}
            <div
                className={`
                ${styles.text_input__wrapper} ${styles[`text_input_${fieldName}`]}
                `}
            >
                <textarea
                    type="text"
                    placeholder={placeholder}
                    name={fieldName}
                    defaultValue={value}
                    onChange={onChange}
                />
            </div>
        </>
    );
};

TextArea.propTypes = {
    fieldName: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    setValue: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string
};

export default TextArea;
